<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 36" enable-background="new 0 0 36 36" xml:space="preserve">
    <line x1="4.5" y1="3.75" x2="31.5" y2="3.75" stroke="currentColor" stroke-width="3" stroke-linecap="round"></line>
    <line x1="4.5" y1="12.75" x2="31.5" y2="12.75" stroke="currentColor" stroke-width="3" stroke-linecap="round"></line>
    <line x1="4.5" y1="21.75" x2="31.5" y2="21.75" stroke="currentColor" stroke-width="3" stroke-linecap="round"></line>
    <line x1="4.5" y1="30.75" x2="31.5" y2="30.75" stroke="currentColor" stroke-width="3" stroke-linecap="round"></line>
</svg>
